// extracted by mini-css-extract-plugin
module.exports = {"card":"WeatherCard_card__1K-Xq","footer":"WeatherCard_footer__11Gkl","image":"WeatherCard_image__1xWkx","date":"WeatherCard_date__1W9rp"};